import React, { useContext } from 'react';
import { useNavigate } from 'react-router';

import { StepProps } from '@/widgets/ServiceFormTemplate';

import { InvoiceStatus } from '@/shared/types';
import { ConditionView, StepControlPanel } from '@/shared/ui';

import { Result } from '@/components/Forms/Steps/Result';

import { usePaymentShortPolling } from '@/hooks/usePaymentShortPolling';

import { ROUTES } from '@/router/config';

import AuthContext from '@/contexts/Auth/AuthContext';

import { localStorageController } from '../../../../../../../Cache';
import { PAY_01_OPER_ID } from '../../lib/constants';

export interface ServicePaymentResultProps {
  invoiceStatus?: Nullable<InvoiceStatus>;
  paymentShortPolling: Pick<
    ReturnType<typeof usePaymentShortPolling>,
    'isShortPollingInProgress' | 'onResetPollingData'
  >;
}

export const ServicePaymentResult: React.FC<StepProps<ServicePaymentResultProps>> = ({
  serviceCode,
  invoiceStatus,
  paymentShortPolling: { onResetPollingData },
  specificStep,
}) => {
  const navigate = useNavigate();
  const { isLoggedIn } = useContext(AuthContext);

  return (
    <>
      <Result variant="new" serviceCode={serviceCode} isForAnonym={!isLoggedIn} invoiceStatus={invoiceStatus} />

      <ConditionView
        if={invoiceStatus === InvoiceStatus.SUCCESS}
        else={<StepControlPanel next={() => navigate(ROUTES.HOME)} nextBtnText="На головну" withArrow={false} />}
      >
        <StepControlPanel
          prev={() => {
            specificStep(1);
            onResetPollingData?.();
            localStorageController.clearCachedEndpoint(PAY_01_OPER_ID);
          }}
          prevBtnText="Оплатити іншу послугу"
          next={() => {
            navigate(ROUTES.HOME);
            localStorageController.clearCachedEndpoint(PAY_01_OPER_ID);
          }}
          nextBtnText="На головну"
          prevWithArrow={false}
          withArrow={false}
        />
      </ConditionView>
    </>
  );
};
